import $ from "jquery";
import CONFIG from "@bd-core/config";
import Storage from "@bd-utils/storage";

export default class BackgroundAudio {
    init() {
        // Don't run this on static page
        if (!CONFIG.game.cfgLimit) return false;

        /**
         * @type {JQuery<HTMLAudioElement>}
         */
        this.$audio = $(".backgroundAudio__audio");
        this.$bgAudio = $(".backgroundAudio");

        if (!this.$audio.length) return;

        this.play();
        $(document).on(
            "click",
            ".backgroundAudio__control",
            this.togglePlay.bind(this),
        );
    }

    _setAudioCurrentTime(currentTime) {
        let states = Storage.get("states", {});
        if (!states?.audio) states.audio = 0;
        states.audio = currentTime;
        return Storage.set("states", states);
    }

    _getAudioCurrentTime() {
        const states = Storage.get("states", {});
        const currentTime = states?.audio || 0;

        return currentTime;
    }

    togglePlay() {
        if (!this.$audio.length) return;
        const isPaused = this.$audio[0].paused;
        isPaused ? this.play() : this.pause();
    }

    isPlaying() {
        return this.$audio.length && !this.$audio[0].paused;
    }

    isPaused() {
        if (!this.$audio.length) return true;
        return this.$audio[0].paused;
    }

    play() {
        if (!this.$audio.length) return;

        const isPaused = this.$audio[0].paused;
        if (!isPaused) return;

        this.$audio[0].currentTime = this._getAudioCurrentTime();

        this.$audio[0]
            .play()
            .then(() => this.$bgAudio.addClass("is-playing"))
            .catch((err) => console.error("Can't auto-play audio", err));
    }

    pause() {
        if (!this.$audio.length) return;
        const isPaused = this.$audio[0].paused;
        if (isPaused) return;

        try {
            this.$audio[0].pause();
            this.$bgAudio.removeClass("is-playing");
            this._setAudioCurrentTime(this.$audio[0].currentTime);
        } catch (err) {
            console.error("Can't pause audio", err);
        }
    }
}
